import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, PenSquare, LogIn } from 'lucide-react';
import { authorLogin } from '../services/authorApi';
import { toast } from '../hooks/use-toast';

const AuthorLoginPage = () => {
  const nav = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await authorLogin(email.trim(), password);
      nav('/author');
    } catch (err) {
      toast({ title: 'Sign-in failed', description: err.response?.data?.detail || 'Invalid email or password', variant: 'destructive' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#e2ede6] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 text-[#0f5c3d]">
            <PenSquare className="w-5 h-5" />
            <span className="font-serif text-2xl">Author sign in</span>
          </div>
          <p className="mt-2 text-sm text-[#0b1a2e]/70">Manage your blog and profile on Emerald Corporates.</p>
        </div>
        <form onSubmit={onSubmit} className="bg-white rounded-2xl shadow-sm border border-black/5 p-8 space-y-5">
          <div>
            <label className="block text-xs font-semibold uppercase tracking-widest text-[#0b1a2e]/70 mb-1.5">Email</label>
            <input
              data-testid="author-login-email"
              type="email" required autoFocus
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-[#0f5c3d]/15 rounded-lg px-3 py-2.5 text-sm"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <label className="block text-xs font-semibold uppercase tracking-widest text-[#0b1a2e]/70 mb-1.5">Password</label>
            <input
              data-testid="author-login-password"
              type="password" required
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-[#0f5c3d]/15 rounded-lg px-3 py-2.5 text-sm"
              placeholder="Your temporary or set password"
            />
          </div>
          <button
            data-testid="author-login-submit"
            type="submit" disabled={busy}
            className="w-full inline-flex items-center justify-center gap-2 bg-[#0f5c3d] text-white rounded-full py-3 text-sm font-semibold hover:bg-[#0b4d33] transition disabled:opacity-50"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <LogIn className="w-4 h-4" />}
            Sign in
          </button>
          <div className="text-xs text-[#0b1a2e]/60 text-center pt-2 border-t border-black/5">
            Not an author? <a href="/login" className="text-[#0f5c3d] font-medium">Admin sign-in</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AuthorLoginPage;
